export * from './referenzen-hochladen-post-request.interface';
export * from './referenzen-hochladen-post-response.interface';
export * from './referenzen-hochladen-post.shapes';
